import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { GlobalSetting } from '../entities/global-setting.js';
import { mongo } from '../server/mongo.js';

export const getLegacyGlobalSetting = registerQuery({
  operationName: 'getLegacyGlobalSetting',
  type: () => GlobalSetting,
  params: [],
  resolve: () => {
    return async (gqlFields: BaseQLSelectionSet<GlobalSetting>) => {
      const existingGlobalSetting = await mongo().collection(GlobalSetting._collectionName).findOne({});
      if (existingGlobalSetting) return existingGlobalSetting as unknown as GlobalSetting;

      const newGlobalSetting = new GlobalSetting({});
      await newGlobalSetting.create();
      return newGlobalSetting;
    };
  },
});
